"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _get2 = _interopRequireDefault(require("@babel/runtime/helpers/get"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _listField = _interopRequireDefault(require("./list-field"));

var _textField = _interopRequireDefault(require("./text-field"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var TextListField = /*#__PURE__*/function (_ListField) {
  (0, _inherits2.default)(TextListField, _ListField);

  var _super = _createSuper(TextListField);

  function TextListField() {
    var _this;

    (0, _classCallCheck2.default)(this, TextListField);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_className", 'TextListField');
    return _this;
  }

  (0, _createClass2.default)(TextListField, [{
    key: "_create",
    value: function _create(props) {
      (0, _get2.default)((0, _getPrototypeOf2.default)(TextListField.prototype), "_create", this).call(this, props);
      this.set({
        schema: {
          component: 'Form',
          fields: [{
            name: 'fieldFactory',
            required: false
          }, {
            name: 'minLength',
            component: 'IntegerField',
            label: 'Min Length',
            docLevel: 'basic'
          }, {
            name: 'maxLength',
            component: 'IntegerField',
            label: 'Max Length',
            docLevel: 'basic'
          }, {
            name: 'minWords',
            component: 'IntegerField',
            label: 'Min Words',
            docLevel: 'basic'
          }, {
            name: 'maxWords',
            component: 'IntegerField',
            label: 'Max Words',
            docLevel: 'basic'
          }, {
            name: 'invalidRegExp',
            component: 'TextField',
            label: 'Invalid RegExp',
            docLevel: 'basic'
          }, {
            name: 'multiline',
            component: 'BooleanField',
            label: 'Multiline',
            docLevel: 'basic'
          }]
        }
      });

      this._setDefaults(props, {
        startWithField: true
      });
    }
  }, {
    key: "_newField",
    value: function _newField(index) {
      return new _textField.default(_objectSpread({
        name: index,
        required: false
      }, this.get(['block', 'fullWidth', 'minLength', 'maxLength', 'minWords', 'maxWords', 'invalidRegExp', 'multiline'])));
    }
  }, {
    key: "set",
    value: function set(props) {
      (0, _get2.default)((0, _getPrototypeOf2.default)(TextListField.prototype), "set", this).call(this, props);

      this._setForAllFields(props, ['minLength', 'maxLength', 'minWords', 'maxWords', 'invalidRegExp', 'multiline']);
    }
  }]);
  return TextListField;
}(_listField.default);

exports.default = TextListField;